var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['filters_bottom', {sm: _vm.isHavingSeveralClubs}]},[_c('BranchFilter',{key:this.branchFilterComponentKey}),_c('div',{staticClass:"filters_bottom_right"},[_c('div',{staticClass:"checkbox_group"},[_c('OnlineFilter'),_c('RegistrationFilter'),_c('PayFilter')],1),_c('FiltersResetButton',{attrs:{"position":"right"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }